import { API_URLS } from '../helpers/api/API_URLS';
import { basicJSONPOST } from '../helpers/api/fetchParams';

export async function getAccountDetails() {
    var token = localStorage.getItem("token");
    var body = {
        "format": "json",
        "logs": 1,
    }
    const response = await fetch(API_URLS.API + 'uptime/getAccountDetails', basicJSONPOST(token, body));
    if (!response.ok) {
        const message = "An error has occured: " + response.status;
        throw new Error(message);
    }
    const data = await response.json();
    // add monitor total to the response data object
    data.account['total_monitors'] = data.account.up_monitors + data.account.down_monitors;
    return data.account;
}

export async function getMonitorLists(pageCount) {
    var token = localStorage.getItem("token");
    let monitors = [];
    for (let i = 0; i < pageCount; i++) {
        let offset = i * 50;
        var options = {
            "format": "json",
            "logs": 1,
            "all_time_uptime_ratio": 1,
            "custom_uptime_ratios": 7,
            "ssl": 1,
            "offset": offset
        };
        const response = await fetch(API_URLS.API + 'uptime/getMonitors', basicJSONPOST(token, options))
        if (!response.ok) {
            const message = "An error has occured: " + response.status;
            throw new Error(message);
        }
        const data = await response.json();
        monitors = monitors.concat(data.monitors)
    }
    return monitors;
}

export async function addNewMonitor(name, url) {
    var token = localStorage.getItem("token");
    var body = {
        "format": "json",
        "type": 1,
        "url": url,
        "friendly_name": name,
        "interval": 60,
        "alert_contacts": "0265574_0_0-2360498_0_0-2608970_0_0-2608971_0_0-2647792_0_0-2846848_0_0-2898344_0_0-2898345_0_0",
    }
    const response = await fetch(API_URLS.API + 'uptime/newMonitor', basicJSONPOST(token, body));
    if (!response.ok) {
        const message = "An error has occured: " + response.status;
        throw new Error(message);
    }
    const data = await response.json();
    console.log(data);
    return data;
}

export async function updateMonitor(id, action) {
    var token = localStorage.getItem("token");
    var strconfirm = false;
    if (action === "deleteMonitor") {
        strconfirm = window.confirm("Are you sure you want to delete?");
    } else if (action === "resetMonitor") {
        strconfirm = window.confirm("Are you sure you want to reset the monitor's stats?");
    }
    if (strconfirm === true) {
        var body = {
            "format": "json",
            "id": id
        }
        const response = await fetch(API_URLS.API + 'uptime/' + action, basicJSONPOST(token, body));
        if (!response.ok) {
            const message = "An error has occured: " + response.status;
            throw new Error(message);
        }
        const data = await response.json();
        console.log(data);
        return data;
    }
}


// WEBPACK FOOTER //
// ./src/data/serviceUptime.js